import {SearchIcon, SelectSearch, SelectSearchWrapper, SelectTitle} from "./Styled";
import React from "react";
import PropTypes from "prop-types";
import {MULTI_SELECT} from "../utils";

const SelectSearchHandler = ({
    withSearch,
    getInputProps,
    isOpen,
    inputValue,
    resetInputValue,
    placeholder,
    menuLegend,
    type,
    searchPlaceholder,
}) => {
    return (
        <>
            <SelectSearch withSearch={withSearch} isOpen={isOpen}>
                <SelectSearchWrapper>
                    <input
                        type="text"
                        {...getInputProps()}
                        placeholder={searchPlaceholder ?? `Search ${placeholder}`}
                        autoComplete="off"
                        data-testid="select-searchInput"
                    />
                    <SearchIcon
                        isSearchInputValue={inputValue?.length > 0}
                        onClick={resetInputValue}
                        data-testid="select-searchCancelButton"
                    />
                </SelectSearchWrapper>
            </SelectSearch>
            <SelectTitle>
                {menuLegend ? menuLegend : type === MULTI_SELECT ? "Choose Options" : "SELECT ONE"}
            </SelectTitle>
        </>
    );
};
SelectSearchHandler.propTypes = {
    withSearch: PropTypes.bool,
    getInputProps: PropTypes.func,
    isOpen: PropTypes.bool,
    inputValue: PropTypes.string,
    resetInputValue: PropTypes.func,
    placeholder: PropTypes.string,
    menuLegend: PropTypes.string,
    type: PropTypes.string,
    searchPlaceholder: PropTypes.string,
};
export default SelectSearchHandler;
